export const initUsers = new Map()

export const initUser = {
  id: -1,
  isMaster: false,
  isPlayer: false,
  isObserver: false,
  name: '',
  memo: '',
  chatAnswer: false,
  color: {
    index: 0,
    custom: '#ffffff'
  },
  delay: 0
}
